<template>
  <v-dialog
    v-model="showUnsavedDialog"
    maxWidth="45%"
  >
    <v-card class="w-100">
      <v-card-title
        class="headline"
        style="font-weight: 500; position: relative;"
      >
        {{ onApprovePress ? $t('workOrderPage.approveWorkOrder') : $t('workOrderPage.exitWorkOrder') }}
        <v-spacer />
        <v-btn
          icon
          class="close-btn"
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="my-6" />
      <v-card-text
        class="d-flex align-center"
        style="font-size: 18px;"
      >
        <v-icon
          color="error"
          size="32"
          class="mr-3"
        >
          mdi-alert-circle-outline
        </v-icon>
        <span>{{ onApprovePress ? $t('workOrderPage.unsavedComment.onApprovePress') : $t('workOrderPage.unsavedComment.onExit') }}</span>
      </v-card-text>
      <v-divider class="my-6" />
      <v-card-actions class="justify-end">
        <v-btn
          text
          style="min-width: 180px; text-transform: none;"
          @click="$emit('exitWithoutSaving')"
        >
          {{ onApprovePress ? $t('forms.labels.approveWithoutSaving') : $t('forms.labels.exitWithoutSaving') }}
        </v-btn>
        <v-btn
          color="primary"
          dark
          style="min-width: 180px;text-transform: none;"
          @click="$emit('saveAndExit')"
        >
          {{ onApprovePress ? $t('forms.labels.approveAndSave') : $t('forms.labels.saveAndExit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'UnsavedConfirmModal',
    props: {
        showUnsavedDialog: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Exit',
        },
        onApprovePress: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
